export default __webpack_public_path__ + "static/indoor27-36a1ad615ce57d38572ffe79cd29d8df.webp";